import React, { useEffect, useState } from "react";
import Clocks from "../components/Clocks";

export default function About({ config }) {
  const aboutUs = config?.aboutUs.split("\n");

  return (
    <div className="about-container">
      <div className="about">
        <h2>معرفی صرافی iex</h2>
        <div className="aboutUsTexts">
          {aboutUs.map((el, i, row) =>
            i + 1 !== row.length ? <p>{el}</p> : <h4>{el}</h4>
          )}
        </div>
        <div className="infos">
          <span>
            <span>شماره ثبت: </span>
            <span>۵۱۰۲۸۳</span>
          </span>
          <span>
            <span>کد صرافی: </span>
            <span>۱۷۸۷۳</span>
          </span>
          <span>
            <span>کد اقتصادی: </span>
            <span>۴۱۱۵۴۸۸۶۸۴۹۸</span>
          </span>
          <span>
            <span>شناسه ملی: </span>
            <span>۱۴۰۰۶۸۱۱۶۶۳</span>
          </span>
        </div>
      </div>
      <Clocks />
    </div>
  );
}
